module.exports = __webpack_public_path__ + "assets/262125d7a6b0361d413e5ca6194e6a1d.png";